export enum TeamListFilter {
  Owned = 'owned',
  Public = 'public',
  All = 'all',
}

/** member.role (also valid for chat_message.speaker_role) */
export enum TeamRole {
  Operative = 'operative',
  Chair = 'chair',
  Watchdog = 'watchdog',
  Envoy = 'envoy',
}

export const SpeakerRole = TeamRole;

/** team.category */
export enum TeamCategory {
  OPS = 'OPS',
  CORTEX = 'CORTEX',
  ARCADE = 'ARCADE',
  VITALS = 'VITALS',
}

/** Team list filter accepted by teams list endpoints */
export enum TeamsListFilter {
  All = 'all',
  Owned = 'owned',
  Public = 'public',
}

/** team.model_mode — which per-member model slot the team currently runs on */
export enum TeamModelMode {
  Economical = 'economical',
  Performance = 'performance',
}

/** Provenance of a member model change: genuine user pick vs. system fallback promotion */
export enum ModelChangeIntent {
  UserSelection = 'user_selection',
  SystemPromotion = 'system_promotion',
}

export const TEAM_ROLE_VALUES = Object.freeze(Object.values(TeamRole));

export const SPEAKER_ROLE_VALUES = TEAM_ROLE_VALUES;

export const TEAM_CATEGORY_VALUES = Object.freeze(Object.values(TeamCategory));

export const TEAMS_LIST_FILTER_VALUES = Object.freeze(Object.values(TeamsListFilter));
